var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0479 5.8105C20.3609 3.7655 18.7309 2.1355 16.6869 1.4495C12.9129 0.1835 9.08594 0.1835 5.31294 1.4495C3.26794 2.1355 1.63794 3.7655 0.951941 5.8095C-0.314059 9.5835 -0.314059 13.4095 0.951941 17.1835C1.63794 19.2275 3.26794 20.8585 5.31294 21.5445C7.19694 22.1765 9.10994 22.4965 10.9999 22.4965C14.0219 22.4965 17.0839 22.0985 20.1009 21.3135C20.4519 21.2225 20.7259 20.9485 20.8169 20.5975C21.6019 17.5805 21.9999 14.5185 21.9999 11.4965C21.9999 9.6075 21.6799 7.6945 21.0479 5.8095V5.8105ZM6.93594 6.4755H9.83994C10.3919 6.4755 10.8399 6.9235 10.8399 7.4755C10.8399 8.0275 10.3919 8.4755 9.83994 8.4755H6.93594C6.38394 8.4755 5.93594 8.0275 5.93594 7.4755C5.93594 6.9235 6.38394 6.4755 6.93594 6.4755ZM15.0639 16.5185H6.93594C6.38394 16.5185 5.93594 16.0705 5.93594 15.5185C5.93594 14.9665 6.38394 14.5185 6.93594 14.5185H15.0639C15.6159 14.5185 16.0639 14.9665 16.0639 15.5185C16.0639 16.0705 15.6159 16.5185 15.0639 16.5185ZM16.0639 12.4975H5.93594C5.38394 12.4975 4.93594 12.0495 4.93594 11.4975C4.93594 10.9455 5.38394 10.4975 5.93594 10.4975H16.0639C16.6159 10.4975 17.0639 10.9455 17.0639 11.4975C17.0639 12.0495 16.6159 12.4975 16.0639 12.4975Z",
    fill: "#17282F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.c92a8611e0dc5ca2ac6159753d5dd77a.svg";
export { ForwardRef as ReactComponent };